export default __webpack_public_path__ + "static/media/ddt_interno.dfe1eabd.svg";